import { useEffect, useState } from "react";
import { creatorFetch } from "../adminApi";
import { Field, ImageField, SaveBar } from "../admin/sections";
import { StatusBadge, Toggle } from "./bits";

/* ---------- আমার দোকান ---------- */
export function ShopTab({ data, refresh, goCustomer }) {
  const [f, setF] = useState({
    name: data.shop?.name || "",
    latin: data.shop?.latin || "",
    blurb: data.shop?.blurb || "",
    image: data.shop?.image || "",
  });
  const [live, setLive] = useState(data.shop ? data.shop.active !== false : true);
  const [done, setDone] = useState(false);
  const [toggling, setToggling] = useState(false);

  const save = async () => {
    try {
      await creatorFetch("/creator/shop", { method: "PUT", body: JSON.stringify(f) });
      setDone(true);
      refresh();
      setTimeout(() => setDone(false), 2500);
    } catch (e) {
      alert(e.message);
    }
  };

  const flipLive = async () => {
    setToggling(true);
    try {
      await creatorFetch("/creator/shop", { method: "PUT", body: JSON.stringify({ ...f, active: !live }) });
      setLive(!live);
      refresh();
    } catch (e) {
      alert(e.message);
    }
    setToggling(false);
  };

  return (
    <div className="max-w-2xl space-y-5" data-testid="creator-section-shop">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <StatusBadge live={live} testid="shop-status-badge" />
        <Toggle on={live} onChange={flipLive} label={live ? "দোকান খোলা (LIVE)" : "দোকান বন্ধ (DRAFT)"} testid="shop-live-toggle" />
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          data-testid="shop-see-view"
          onClick={() => goCustomer("hat", "রঙের হাট")}
          className="rounded-full border border-gold/40 px-5 py-2.5 text-sm text-gold transition-colors hover:bg-gold hover:text-dusk"
        >
          Shop দেখুন
        </button>
        <button
          data-testid="shop-go-add-product"
          onClick={() => window.dispatchEvent(new CustomEvent("creator-nav", { detail: { tab: "products", add: true } }))}
          className="rounded-full bg-gold px-5 py-2.5 text-sm font-medium text-dusk transition-transform hover:scale-[1.03]"
        >
          Product যোগ করুন
        </button>
      </div>
      <Field label="ঘরের নাম" value={f.name} onChange={(v) => setF({ ...f, name: v })} testid="my-shop-name" />
      <Field label="ইংরেজি পরিচয়" value={f.latin} onChange={(v) => setF({ ...f, latin: v })} testid="my-shop-latin" />
      <Field label="পরিচয়-বাক্য" value={f.blurb} onChange={(v) => setF({ ...f, blurb: v })} area testid="my-shop-blurb" />
      <ImageField label="ঘরের ছবি" value={f.image} onChange={(v) => setF({ ...f, image: v })} />
      <SaveBar saving={false} done={done} onSave={save} testid="save-my-shop" />
      <p className="text-xs text-sand/45">DRAFT-এ থাকলে দোকানের পথ গ্রামবাসীর চোখে পড়বে না।</p>
    </div>
  );
}

/* ---------- আমার পণ্য ---------- */
export function digitsOf(priceStr) {
  const bn = "০১২৩৪৫৬৭৮৯";
  let out = "";
  for (const ch of priceStr || "") {
    const bi = bn.indexOf(ch);
    if (bi >= 0) out += bi;
    else if (ch >= "0" && ch <= "9") out += ch;
  }
  return Number(out) || 0;
}

export function ProductsTab({ data, refresh, startAdd }) {
  const [form, setForm] = useState(null);
  const [editId, setEditId] = useState(null);
  const [aiFor, setAiFor] = useState(null);
  const shopKey = data.shop?.key || "";

  useEffect(() => {
    if (startAdd && !form) startNew();
    // eslint-disable-next-line
  }, [startAdd]);

  const startNew = () => {
    setEditId(null);
    setForm({
      shop_key: shopKey, title: "", latin: "", price: "", artisan: data.shop?.name || "", img: "", tag: "",
      order: (data.products.length + 1) * 10, active: true,
      story: "", material: "", sizes: [], custom_order: true, bulk_order: false, qty: 1, price_num: 0,
    });
  };
  const startEdit = (p) => {
    setEditId(p.id);
    setForm({ ...p, shop_key: shopKey });
  };

  const save = async () => {
    try {
      const body = { ...form, price_num: digitsOf(form.price) };
      if (editId) await creatorFetch(`/creator/products/${editId}`, { method: "PUT", body: JSON.stringify(body) });
      else await creatorFetch("/creator/products", { method: "POST", body: JSON.stringify(body) });
      setForm(null);
      setEditId(null);
      refresh();
    } catch (e) {
      alert(e.message);
    }
  };

  const del = async (id) => {
    if (!window.confirm("পণ্যটি মুছে যাবে?")) return;
    await creatorFetch(`/creator/products/${id}`, { method: "DELETE" });
    refresh();
  };

  return (
    <div className="max-w-3xl" data-testid="creator-section-products">
      <button data-testid="add-my-product" onClick={startNew} className="mb-5 rounded-full bg-gold px-6 py-3 text-sm font-medium text-dusk transition-transform hover:scale-[1.03]">
        নতুন পণ্য যোগ করুন
      </button>
      <div className="grid gap-3 sm:grid-cols-2">
        {data.products.map((p) => (
          <div key={p.id} className="overflow-hidden rounded-2xl border border-gold/15 bg-dusk/50" data-testid={`my-product-${p.id}`}>
            <img src={p.img?.startsWith("http") ? p.img : `${process.env.REACT_APP_BACKEND_URL}${p.img || ""}`} alt="" className="h-36 w-full object-cover" />
            <div className="p-4">
              <div className="flex items-start justify-between gap-2">
                <p className="font-display text-lg leading-snug text-sand">{p.title}</p>
                <StatusBadge live={p.active !== false} testid={`product-status-${p.id}`} />
              </div>
              <p className="mt-1 text-sm text-gold">{p.price}</p>
              <p className="mt-0.5 truncate text-xs text-sand/50">মজুত: {p.qty ?? "—"} • {p.custom_order !== false ? "কাস্টম হয়" : "কাস্টম নয়"}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                <button data-testid={`edit-my-product-${p.id}`} onClick={() => startEdit(p)} className="rounded-full border border-gold/30 px-4 py-1.5 text-xs text-gold transition-colors hover:bg-gold hover:text-dusk">সাধুন</button>
                <button data-testid={`ai-my-product-${p.id}`} onClick={() => setAiFor(p)} className="rounded-full border border-vermilion/50 px-4 py-1.5 text-xs text-vermilion transition-colors hover:bg-vermilion hover:text-alpana">দাম-সেটিং</button>
                <button data-testid={`del-my-product-${p.id}`} onClick={() => del(p.id)} className="rounded-full border border-red-400/30 px-4 py-1.5 text-xs text-red-300 transition-colors hover:bg-red-400 hover:text-dusk">মুছুন</button>
              </div>
            </div>
          </div>
        ))}
        {data.products.length === 0 && <p className="text-sm text-sand/50">এখনো পণ্য নেই — প্রথম পণ্য যোগ করুন।</p>}
      </div>

      {form && (
        <div className="mt-6 space-y-4 rounded-2xl border border-gold/25 bg-plaster p-5" data-testid="product-form">
          <h4 className="font-display text-lg text-gold">{editId ? "পণ্য সাধুন" : "নতুন পণ্য"}</h4>
          <Field label="পণ্যের নাম" value={form.title} onChange={(v) => setForm({ ...form, title: v })} testid="my-product-title" />
          <ImageField label="পণ্যের ছবি" value={form.img} onChange={(v) => setForm({ ...form, img: v })} />
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="দাম — যেমন ₹ ১,৯৯৯" value={form.price} onChange={(v) => setForm({ ...form, price: v })} testid="my-product-price" />
            <Field label="মাপ — কমা দিয়ে, যেমন স, এম, এল" value={(form.sizes || []).join(", ")} onChange={(v) => setForm({ ...form, sizes: v.split(",").map((x) => x.trim()).filter(Boolean) })} testid="my-product-sizes" />
            <Field label="উপাদান — যেমন সিল্ক-সুতি" value={form.material || ""} onChange={(v) => setForm({ ...form, material: v })} testid="my-product-material" />
            <Field label="মজুত সংখ্যা" value={String(form.qty ?? 1)} onChange={(v) => setForm({ ...form, qty: Number(v) || 0 })} testid="my-product-qty" />
          </div>
          <Field label="ছোট বর্ণনা" value={form.story || ""} onChange={(v) => setForm({ ...form, story: v })} area testid="my-product-story" />
          <div className="flex flex-wrap gap-3">
            <Toggle on={form.custom_order !== false} onChange={(v) => setForm({ ...form, custom_order: v })} label="কাস্টম-অর্ডার হয়" testid="my-product-custom" />
            <Toggle on={!!form.bulk_order} onChange={(v) => setForm({ ...form, bulk_order: v })} label="বাল্ক-অর্ডার হয়" testid="my-product-bulk" />
          </div>
          <details className="text-xs text-sand/45">
            <summary className="cursor-pointer">অতিরিক্ত (ইংরেজি নাম, ট্যাগ, ক্রম)</summary>
            <div className="mt-3 grid gap-4 sm:grid-cols-2">
              <Field label="ইংরেজি নাম" value={form.latin} onChange={(v) => setForm({ ...form, latin: v })} testid="my-product-latin" />
              <Field label="ট্যাগ" value={form.tag} onChange={(v) => setForm({ ...form, tag: v })} testid="my-product-tag" />
              <Field label="ক্রম" value={String(form.order)} onChange={(v) => setForm({ ...form, order: Number(v) || 0 })} testid="my-product-order" />
            </div>
          </details>
          <SaveBar saving={false} done={false} onSave={save} testid="save-my-product" />
          <button data-testid="cancel-my-product" onClick={() => { setForm(null); setEditId(null); }} className="text-sm text-sand/60 hover:text-sand">বাতিল</button>
        </div>
      )}

      {aiFor && <AiSalesModal product={aiFor} onClose={() => setAiFor(null)} refresh={refresh} />}
    </div>
  );
}

/* ---------- AI-বিক্রয়-সেটিংস ---------- */
function AiSalesModal({ product, onClose, refresh }) {
  const listed = Number(product.price_num) || 0;
  const [minP, setMinP] = useState((product.min_price ?? Math.round(listed * 0.875)) || 0);
  const [nego, setNego] = useState(product.negotiation !== false);
  const [custom, setCustom] = useState(product.custom_order !== false);
  const [bulk, setBulk] = useState(!!product.bulk_order);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const save = async () => {
    setErr("");
    try {
      await creatorFetch(`/creator/product-ai/${product.id}`, {
        method: "PUT",
        body: JSON.stringify({ min_price: minP, negotiation: nego, custom_order: custom, bulk_order: bulk }),
      });
      setDone(true);
      refresh();
      setTimeout(onClose, 900);
    } catch (e) {
      setErr(e.message);
    }
  };

  const maxDiscount = Math.max(0, listed - minP);

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-dusk/90 p-4 backdrop-blur-md" onClick={onClose} data-testid="ai-sales-modal">
      <div className="w-full max-w-md rounded-2xl border border-gold/25 bg-plaster p-6" onClick={(e) => e.stopPropagation()}>
        <h4 className="font-display text-xl text-gold">AI-বিক্রয়-সেটিংস</h4>
        <p className="mt-1 text-sm text-sand/70">{product.title}</p>
        <div className="mt-4 space-y-1 rounded-xl border border-gold/15 bg-earthen/70 p-4 text-sm">
          <div className="flex justify-between"><span className="text-sand/55">তালিকাভুক্ত দাম</span><span className="text-sand">{product.price}</span></div>
          <div className="flex justify-between"><span className="text-sand/55">ন্যূনতম দাম</span><span className="text-gold">₹{Number(minP || 0).toLocaleString("en-IN")}</span></div>
          <div className="flex justify-between"><span className="text-sand/55">সর্বোচ্ছ ছাড়</span><span className="text-sand/80">₹{maxDiscount.toLocaleString("en-IN")}</span></div>
        </div>
        <div className="mt-4 space-y-3">
          <Field label="ন্যূনতম দাম (এর নিচে AI দিতে পারবে না)" value={String(minP)} onChange={(v) => setMinP(Number(v) || 0)} testid="ai-min-price" />
          <div className="flex flex-wrap gap-2">
            <Toggle on={nego} onChange={setNego} label={nego ? "দরদাম: চালু" : "দরদাম: বন্ধ"} testid="ai-negotiation-toggle" />
            <Toggle on={custom} onChange={setCustom} label={custom ? "কাস্টম-অর্ডার: হ্যাঁ" : "কাস্টম-অর্ডার: না"} testid="ai-custom-toggle" />
            <Toggle on={bulk} onChange={setBulk} label={bulk ? "বাল্ক-অর্ডার: হ্যাঁ" : "বাল্ক-অর্ডার: না"} testid="ai-bulk-toggle" />
          </div>
        </div>
        <p className="mt-4 rounded-xl border border-vermilion/30 bg-vermilion/10 p-3 text-xs leading-relaxed text-sand/80" data-testid="ai-limit-note">
          AI আপনার নির্ধারিত সীমার বাইরে দাম কমাতে পারবে না।
        </p>
        {err && <p className="mt-2 text-xs text-red-300">{err}</p>}
        <div className="mt-5 flex items-center gap-3">
          <SaveBar saving={false} done={done} onSave={save} testid="save-ai-settings" />
          <button data-testid="ai-close" onClick={onClose} className="text-sm text-sand/60 hover:text-sand">বন্ধ</button>
        </div>
      </div>
    </div>
  );
}

/* ---------- আমার গল্প ---------- */
export function StoryTab({ data, refresh }) {
  const [f, setF] = useState({
    story: data.shop?.story || "",
    craft: data.shop?.craft || "",
    location: data.shop?.location || "",
    languages: data.shop?.languages || "",
    years: data.shop?.years ?? 0,
  });
  const [done, setDone] = useState(false);

  const save = async () => {
    try {
      await creatorFetch("/creator/shop", { method: "PUT", body: JSON.stringify(f) });
      setDone(true);
      refresh();
      setTimeout(() => setDone(false), 2500);
    } catch (e) {
      alert(e.message);
    }
  };

  return (
    <div className="max-w-2xl space-y-4" data-testid="creator-section-story">
      <Field label="আমার গল্প" value={f.story} onChange={(v) => setF({ ...f, story: v })} area testid="my-story" />
      <Field label="আমার কারুকাজ" value={f.craft} onChange={(v) => setF({ ...f, craft: v })} testid="my-craft" />
      <Field label="ঠিকানা" value={f.location} onChange={(v) => setF({ ...f, location: v })} testid="my-location" />
      <Field label="ভাষা" value={f.languages} onChange={(v) => setF({ ...f, languages: v })} testid="my-languages" />
      <Field label="কত বছরের অভিজ্ঞতা" value={String(f.years ?? 0)} onChange={(v) => setF({ ...f, years: Number(v) || 0 })} testid="my-years" />
      <SaveBar saving={false} done={done} onSave={save} testid="save-my-story" />
    </div>
  );
}
